import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { useErrorBoundary } from "component-library";
import { authAxios as axios } from "api-generate-types/src/axios";
import { HALManager, UserManager } from "app/core";
import { AboutMe } from "models";
import { GET_ABOUT_ME_QUERY_KEY } from "pages/Profile/hooks/useGetAboutMe";
import { getApiUrl } from "services/UrlBuilder";

export function useUpdateAboutMe() {
  const queryClient = useQueryClient();
  const captureError = useErrorBoundary();

  return useMutation<AboutMe, AxiosError, { currentAppearance: string }>(
    async (body) => {
      const { data } = await axios.put(
        getApiUrl(HALManager.updateAboutMeUrl(UserManager.userId)),
        body
      );

      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(GET_ABOUT_ME_QUERY_KEY);
      },
      onError: (error) => captureError(error),
    }
  );
}
